import gql from 'graphql-tag';

export const GET_PAYMENT_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getPaymentList(listInfo: $listInfo) {
      payments {
        paymentId
        displayId
        client {
          accountId
          name
        }
        paymentMethod {
          paymentMethodId
          paymentMethodName
        }
        paymentDate
        paymentReference
        amount
        paymentSource
        balanceAmount
        associatedInvoicesCount
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        hasMore
      }
    }
  }
`;

export const GET_PAYMENT = gql`
  query($input: PaymentIdentifierInput!) {
    getPayment(input: $input) {
      paymentId
      displayId
      client {
        accountId
        name
      }
      amount
      paymentDate
      paymentSource
      paymentReference
      paymentMethod {
        paymentMethodId
        paymentMethodName
      }
      balanceAmount
      associatedInvoicesCount
      transactions {
        transactionId
        invoice {
          invoiceId
          displayId
          statusEnum
          totalAmount
          amountDue
          amountPaid
        }
        amount
      }
    }
  }
`;

export const GET_AVAILABLE_CREDITS = gql`
  query($input: RuleConditionInput) {
    getAvailableCredits(input: $input)
  }
`;

export const GET_INVOICE_TRANSACTION_LIST = gql`
  query($input: ListInfoInput!) {
    getInvoiceTransactionList(listInfo: $input) {
      transactions {
        transactionId
        payment {
          paymentId
          displayId
          paymentDate
          paymentMethod {
            paymentMethodId
            paymentMethodName
          }
          paymentReference
        }
        mappings {
          mappingId
          paymentSyncStatus
          errorDetails
        }
        amount
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
    }
  }
`;

export const GET_INVOICE_TRANSACTION_LIST_FOR_STATEMENTS = gql`
  query($listInfo: ListInfoInput!) {
    getInvoiceTransactionList(listInfo: $listInfo) {
      transactions {
        transactionId
        payment {
          paymentId
          displayId
          paymentDate
          paymentMethod {
            paymentMethodId
            paymentMethodName
          }
          paymentReference
        }
        invoice {
          displayId
          invoiceId
        }
        amount
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
        sort {
          attribute
          order
        }
      }
    }
  }
`;

export const GET_PAYMENT_TRANSACTION_LIST = gql`
  query($input: ListInfoInput!) {
    getPaymentTransactionList(listInfo: $input) {
      transactions {
        transactionId
        invoice {
          invoiceId
          displayId
          totalAmount
          amountDue
          statusEnum
        }
        amount
      }
      listInfo {
        page
        pageSize
        totalCount
        hasMore
      }
    }
  }
`;
